let ShipmentStatus = /*#__PURE__*/function (ShipmentStatus) {
  ShipmentStatus["AWAITING_COMPLETION"] = "AWAITING_COMPLETION";
  ShipmentStatus["READY_TO_PURCHASE"] = "READY_TO_PURCHASE";
  ShipmentStatus["PURCHASE_SUCCESS"] = "PURCHASE_SUCCESS";
  ShipmentStatus["CARRIER_PENDING"] = "CARRIER_PENDING";
  ShipmentStatus["CARRIER_OK"] = "CARRIER_OK";
  ShipmentStatus["CARRIER_KO"] = "CARRIER_KO";
  ShipmentStatus["LABELS_KO"] = "LABELS_KO";
  ShipmentStatus["READY_TO_PRINT"] = "READY_TO_PRINT";
  ShipmentStatus["READY_FOR_COLLECTION"] = "READY_FOR_COLLECTION";
  ShipmentStatus["IN_TRANSIT"] = "IN_TRANSIT";
  ShipmentStatus["DELIVERED"] = "DELIVERED";
  ShipmentStatus["CANCELED"] = "CANCELED";
  ShipmentStatus["CANCEL_REQUESTED"] = "CANCEL_REQUESTED";
  ShipmentStatus["RETRY"] = "RETRY";
  ShipmentStatus["OUT_FOR_DELIVERY"] = "OUT_FOR_DELIVERY";
  ShipmentStatus["RETURNED_TO_SENDER"] = "RETURNED_TO_SENDER";
  ShipmentStatus["INCIDENT"] = "INCIDENT";
  return ShipmentStatus;
}({});

export { ShipmentStatus };
//# sourceMappingURL=ShipmentStatus.js.map
